import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import axiosCompany from 'app/api/apiCompany';

/** ************ CLIENTS * */
export const getClients = createAsyncThunk('commonAPI/clients/getClients', async (dispatch) => {
   const params = { ...axiosCompany.apiCompany.filterListDM };
   params.bActive = [true];
   params.bClient = true;

   const response = await axiosCompany.apiCompany.list({ ...params });
   const data = await response.data;

   return data === undefined ? null : data;
});

const clientCommonDataAdapter = createEntityAdapter({
   selectId: (company) => company.iId,
});

export const { selectAll: selectClientsCommon } = clientCommonDataAdapter.getSelectors((state) => state.commonAPI.clients.dataCompanies);

const clientsCommonSlice = createSlice({
   name: 'clients',
   initialState: {
      dataCompanies: clientCommonDataAdapter.getInitialState(),
   },
   extraReducers: {
      [getClients.fulfilled]: (state, { payload }) => {
         clientCommonDataAdapter.setAll(state.dataCompanies, payload);
      },
   },
});

export default clientsCommonSlice.reducer;
